import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

/**
 * Compact FR / EN language switch for the B2B portal.
 *
 * Persists the choice via the existing i18next LanguageDetector
 * (localStorage key `uc.lang`), so the toggle survives reloads and
 * cross-page navigation.
 */
export const PortalLangToggle = () => {
    const { i18n, t } = useTranslation('portal');
    const current = (i18n.resolvedLanguage || i18n.language || 'fr').slice(0, 2);

    const set = (lng) => {
        if (lng === current) return;
        i18n.changeLanguage(lng);
    };

    const btn = (code, label) => (
        <button
            key={code}
            onClick={() => set(code)}
            data-testid={`portal-lang-${code}`}
            aria-pressed={current === code}
            className={`px-2 py-0.5 text-[11px] font-semibold tracking-wider uppercase rounded-full transition-colors ${
                current === code
                    ? 'bg-[#1A1A1A] text-white'
                    : 'text-gray-500 hover:text-[#1A1A1A]'
            }`}
        >
            {label}
        </button>
    );

    return (
        <div
            className="hidden sm:flex items-center gap-1 bg-[#FBF8F6] border border-[#EFE5E1] rounded-full p-0.5"
            data-testid="portal-lang-toggle"
            aria-label={t('lang_label')}
        >
            <Globe size={13} className="text-gray-400 ml-1.5" />
            {btn('fr', 'FR')}
            {btn('en', 'EN')}
        </div>
    );
};

export default PortalLangToggle;
